/* RESPONSIBLE TEAM: team-fin-qa */
import ApplicationSerializer from '../application';

/**
 * Normalizes the /ai_insights/topics response into unique topic records.
 * The API returns { topics: [{ topicName, subtopicId, subtopicName }, ...] }.
 * We extract unique topicName values as records with name as both ID and attribute.
 */
export default class AiTopicSerializer extends ApplicationSerializer {
  normalizeArrayResponse(
    store: any,
    primaryModelClass: any,
    payload: any,
    id: any,
    requestType: any,
  ) {
    let topics: any[] = payload.topics || [];
    let uniqueNames = [...new Set(topics.map((t: any) => t.topicName))];
    let normalized = uniqueNames.map((name) => ({ id: name, name }));
    return super.normalizeArrayResponse(store, primaryModelClass, normalized, id, requestType);
  }
}
